/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * EventType defines possible types for workload events.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1EventType = {
    INVALID: 'EVENT_TYPE_INVALID',
    SURGE: 'EVENT_TYPE_SURGE',
    OOM_KILL: 'EVENT_TYPE_OOM_KILL',
    CONFIGURATION_CHANGEDV2: 'EVENT_TYPE_CONFIGURATION_CHANGEDV2',
    RECOMMENDED_POD_COUNT_CHANGED: 'EVENT_TYPE_RECOMMENDED_POD_COUNT_CHANGED',
    RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_RECOMMENDED_REQUESTS_CHANGED',
    SCALING_POLICY_CREATED: 'EVENT_TYPE_SCALING_POLICY_CREATED',
    SCALING_POLICY_DELETED: 'EVENT_TYPE_SCALING_POLICY_DELETED',
    SCALING_POLICY_UPDATED: 'EVENT_TYPE_SCALING_POLICY_UPDATED',
    SCALING_POLICY_ASSIGNED: 'EVENT_TYPE_SCALING_POLICY_ASSIGNED',
    FAILED_HELM_TEST_HOOK: 'EVENT_TYPE_FAILED_HELM_TEST_HOOK',
    SCALING_POLICY_ORDER_UPDATED: 'EVENT_TYPE_SCALING_POLICY_ORDER_UPDATED',
    MEMORY_PRESSURE_EVICTION: 'EVENT_TYPE_MEMORY_PRESSURE_EVICTION',
    SYSTEM_OVERRIDE_TRIGGERED: 'EVENT_TYPE_SYSTEM_OVERRIDE_TRIGGERED',
    SYSTEM_OVERRIDE_RESET: 'EVENT_TYPE_SYSTEM_OVERRIDE_RESET',
    STARTUP_FAILURE: 'EVENT_TYPE_STARTUP_FAILURE',
    CPU_PRESSURE: 'EVENT_TYPE_CPU_PRESSURE',
    HPA_MAXED_OUT: 'EVENT_TYPE_HPA_MAXED_OUT',
    HPA_ALMOST_MAXED_OUT: 'EVENT_TYPE_HPA_ALMOST_MAXED_OUT',
    UNBOUND_MEMORY_GROWTH: 'EVENT_TYPE_UNBOUND_MEMORY_GROWTH',
    CPU_PRESSURE_RESOLVED: 'EVENT_TYPE_CPU_PRESSURE_RESOLVED',
    NATIVE_VPA_STATE_CHANGED: 'EVENT_TYPE_NATIVE_VPA_STATE_CHANGED',
    GPU_RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_GPU_RECOMMENDED_REQUESTS_CHANGED',
    WORKLOAD_AUTOSCALER_INSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_INSTALLED',
    WORKLOAD_AUTOSCALER_UNINSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_UNINSTALLED',
    UNSCHEDULABLE_RECOMMENDATION: 'EVENT_TYPE_UNSCHEDULABLE_RECOMMENDATION'
} as const;

export type WorkloadoptimizationV1EventType = typeof WorkloadoptimizationV1EventType[keyof typeof WorkloadoptimizationV1EventType];



